export const country = [
  { value: "AD" },
  { value: "AE" },
  { value: "AF" },
  { value: "AG" },
  { value: "AI" },
  { value: "AL" },
  { value: "AM" },
  { value: "AO" },
  { value: "AQ" },
  { value: "AR" },
  { value: "AS" },
  { value: "AT" },
  { value: "AU" },
  { value: "AW" },
  { value: "AX" },
  { value: "AZ" },
  { value: "BA" },
  { value: "BB" },
  { value: "BD" },
  { value: "BE" },
  { value: "BF" },
  { value: "BG" },
  { value: "BH" },
  { value: "BI" },
  { value: "BJ" },
  { value: "BL" },
  { value: "BM" },
  { value: "BN" },
  { value: "BO" },
  { value: "BQ" },
  { value: "BR" },
  { value: "BS" },
  { value: "BT" },
  { value: "BV" },
  { value: "BW" },
  { value: "BY" },
  { value: "BZ" },
  { value: "CA" },
  { value: "CC" },
  { value: "CD" },
  { value: "CF" },
  { value: "CG" },
  { value: "CH" },
  { value: "CI" },
  { value: "CK" },
  { value: "CL" },
  { value: "CM" },
  { value: "CN" },
  { value: "CO" },
  { value: "CR" },
  { value: "CU" },
  { value: "CV" },
  { value: "CW" },
  { value: "CX" },
  { value: "CY" },
  { value: "CZ" },
  { value: "DE" },
  { value: "DJ" },
  { value: "DK" },
  { value: "DM" },
  { value: "DO" },
  { value: "DZ" },
  { value: "EC" },
  { value: "EE" },
  { value: "EG" },
  { value: "EH" },
  { value: "ER" },
  { value: "ES" },
  { value: "ET" },
  { value: "FI" },
  { value: "FJ" },
  { value: "FK" },
  { value: "FM" },
  { value: "FO" },
  { value: "FR" },
  { value: "GA" },
  { value: "GB" },
  { value: "GD" },
  { value: "GE" },
  { value: "GF" },
  { value: "GG" },
  { value: "GH" },
  { value: "GI" },
  { value: "GL" },
  { value: "GM" },
  { value: "GN" },
  { value: "GP" },
  { value: "GQ" },
  { value: "GR" },
  { value: "GS" },
  { value: "GT" },
  { value: "GU" },
  { value: "GW" },
  { value: "GY" },
  { value: "HK" },
  { value: "HM" },
  { value: "HN" },
  { value: "HR" },
  { value: "HT" },
  { value: "HU" },
  { value: "ID" },
  { value: "IE" },
  { value: "IL" },
  { value: "IM" },
  { value: "IN" },
  { value: "IO" },
  { value: "IQ" },
  { value: "IR" },
  { value: "IS" },
  { value: "IT" },
  { value: "JE" },
  { value: "JM" },
  { value: "JO" },
  { value: "JP" },
  { value: "KE" },
  { value: "KG" },
  { value: "KH" },
  { value: "KI" },
  { value: "KM" },
  { value: "KN" },
  { value: "KP" },
  { value: "KR" },
  { value: "KW" },
  { value: "KY" },
  { value: "KZ" },
  { value: "LA" },
  { value: "LB" },
  { value: "LC" },
  { value: "LI" },
  { value: "LK" },
  { value: "LR" },
  { value: "LS" },
  { value: "LT" },
  { value: "LU" },
  { value: "LV" },
  { value: "LY" },
  { value: "MA" },
  { value: "MC" },
  { value: "MD" },
  { value: "ME" },
  { value: "MF" },
  { value: "MG" },
  { value: "MH" },
  { value: "MK" },
  { value: "ML" },
  { value: "MM" },
  { value: "MN" },
  { value: "MO" },
  { value: "MP" },
  { value: "MQ" },
  { value: "MR" },
  { value: "MS" },
  { value: "MT" },
  { value: "MU" },
  { value: "MV" },
  { value: "MW" },
  { value: "MX" },
  { value: "MY" },
  { value: "MZ" },
  { value: "NA" },
  { value: "NC" },
  { value: "NE" },
  { value: "NF" },
  { value: "NG" },
  { value: "NI" },
  { value: "NL" },
  { value: "NO" },
  { value: "NP" },
  { value: "NR" },
  { value: "NU" },
  { value: "NZ" },
  { value: "OM" },
  { value: "PA" },
  { value: "PE" },
  { value: "PF" },
  { value: "PG" },
  { value: "PH" },
  { value: "PK" },
  { value: "PL" },
  { value: "PM" },
  { value: "PN" },
  { value: "PR" },
  { value: "PS" },
  { value: "PT" },
  { value: "PW" },
  { value: "PY" },
  { value: "QA" },
  { value: "RE" },
  { value: "RO" },
  { value: "RS" },
  { value: "RU" },
  { value: "RW" },
  { value: "SA" },
  { value: "SB" },
  { value: "SC" },
  { value: "SD" },
  { value: "SE" },
  { value: "SG" },
  { value: "SH" },
  { value: "SI" },
  { value: "SJ" },
  { value: "SK" },
  { value: "SL" },
  { value: "SM" },
  { value: "SN" },
  { value: "SO" },
  { value: "SR" },
  { value: "SS" },
  { value: "ST" },
  { value: "SV" },
  { value: "SX" },
  { value: "SY" },
  { value: "SZ" },
  { value: "TC" },
  { value: "TD" },
  { value: "TF" },
  { value: "TG" },
  { value: "TH" },
  { value: "TJ" },
  { value: "TK" },
  { value: "TL" },
  { value: "TM" },
  { value: "TN" },
  { value: "TO" },
  { value: "TR" },
  { value: "TT" },
  { value: "TV" },
  { value: "TW" },
  { value: "TZ" },
  { value: "UA" },
  { value: "UG" },
  { value: "UM" },
  { value: "US" },
  { value: "UY" },
  { value: "UZ" },
  { value: "VA" },
  { value: "VC" },
  { value: "VE" },
  { value: "VG" },
  { value: "VI" },
  { value: "VN" },
  { value: "VU" },
  { value: "WF" },
  { value: "WS" },
  { value: "YE" },
  { value: "YT" },
  { value: "ZA" },
  { value: "ZM" },
  { value: "ZW" },
];
